// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.vertical-text[data-v-07ff42e9]\n{\n    -webkit-writing-mode: vertical-rl;\n        -ms-writing-mode: tb-rl;\n            writing-mode: vertical-rl;\n    text-orientation: mixed;\n    text-align: center;\n    color: whitesmoke;\n    margin-top: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
